import { render, staticRenderFns } from "./Rir.vue?vue&type=template&id=755df243&scoped=true"
import script from "./Rir.vue?vue&type=script&lang=js"
export * from "./Rir.vue?vue&type=script&lang=js"
import style0 from "./Rir.vue?vue&type=style&index=0&id=755df243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755df243",
  null
  
)

export default component.exports